import { render, staticRenderFns } from "./invoice-alert.vue?vue&type=template&id=50419e22"
import script from "./invoice-alert.vue?vue&type=script&lang=js"
export * from "./invoice-alert.vue?vue&type=script&lang=js"
import style0 from "./invoice-alert.vue?vue&type=style&index=0&id=50419e22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports